'use client'

import { clsx } from 'clsx'
import { type CSSProperties, type FC, type PropsWithChildren } from 'react'

import { SliderButton, useSliderNavigation } from '../../../slider'
import { getNonEmptyStyleStringValue } from '../../styles/getNonEmptyStyleStringValue'

import styles from './CmsSlider.module.css'

type ResponsiveType<T = string> = {
  desktop?: T
  mobile?: T
  tablet?: T
}

type CmsSliderProps = PropsWithChildren<{
  className?: string
  gap?: ResponsiveType
  itemsPerPage?: ResponsiveType
}>

export const CmsSlider: FC<CmsSliderProps> = ({
  children,
  className,
  gap,
  itemsPerPage,
  ...rest
}) => {
  const { containerProps, leftRef, rightRef } =
    useSliderNavigation<HTMLUListElement>()

  const sliderStyle = {
    '--cms-slider-gap-desktop': getNonEmptyStyleStringValue(gap?.desktop),
    '--cms-slider-gap-mobile': getNonEmptyStyleStringValue(gap?.mobile),
    '--cms-slider-gap-tablet': getNonEmptyStyleStringValue(gap?.tablet),
    '--cms-slider-items-per-page-desktop': getNonEmptyStyleStringValue(
      itemsPerPage?.desktop,
    ),
    '--cms-slider-items-per-page-mobile': getNonEmptyStyleStringValue(
      itemsPerPage?.mobile,
    ),
    '--cms-slider-items-per-page-tablet': getNonEmptyStyleStringValue(
      itemsPerPage?.tablet,
    ),
  } as CSSProperties

  return (
    <div
      {...rest}
      className={clsx(styles['cms-slider'], className)}
      style={sliderStyle}
    >
      <ul className={styles['cms-slider__container']} {...containerProps}>
        {children}
      </ul>
      <SliderButton
        aria-label="previous"
        className={clsx(styles['cms-slider__navigation-button'], 'left-0')}
        direction="left"
        ref={leftRef}
      />
      <SliderButton
        aria-label="next"
        className={clsx(styles['cms-slider__navigation-button'], 'right-0')}
        direction="right"
        ref={rightRef}
      />
    </div>
  )
}
